const filmLocationRouter = {
  route: null,
  name: null,
  title: '演员工会',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont el-icon-trophy',
  filePath: 'view/actors/', // 文件路径
  order: 45,
  inNav: true,
  permission: ['演员列表'],
  children: [
    {
      title: '演员列表',
      type: 'view',
      name: 'actorsList',
      route: '/actors/list',
      filePath: 'view/actors/list.vue',
      inNav: true,
      icon: 'iconfont el-icon-notebook-2',
      permission: ['演员列表'],
    },
    {
      title: '新增演员',
      type: 'view',
      name: 'addActors',
      route: '/actors/add',
      filePath: 'view/actors/create.vue',
      inNav: true,
      icon: 'iconfont el-icon-document-add',
      permission: ['新增演员'],
    },
  ],
}

export default filmLocationRouter
